// Публичный ключ подписи манифестов. Приватный ключ живёт только в окружении API.
export const WIDGET_MANIFEST_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyOLSu/sWdVjjwUx47yXR
VrZ01r3u+pNzhMttVYA1SzFajwwGveGapR9gpg7nexLIkBVoOCQNtlhITSZbY6Yi
V+naWWssHpmPTKjFhzECX/UtGco+AkuhdJo17eOmq+G6FV0bLFytjFc9lkoUjX/U
zZpA8LVLSMs7MRPzLenNKm9vUf3a9ZPl3MkAa7QjhA2eyr5INVZJxinEg26tOreK
F5x5LUF3QF74ais5v/OTB5QR1PA7XNCehhGIhSq7U7pMqtXbiPiFtO/vR/vJMgNG
ulmbXE8Sa+nicf/JFXioJ1fPxcY4eBmV8+uwp0LDTOy2EjGcaWbXP0cY3lfE++7B
FQIDAQAB
-----END PUBLIC KEY-----`;
export const WIDGET_MANIFEST_KEY_ID = 'stand-1';
